<template>
    <div class="CardFooter">
        <TipsAndPrivewDilog :id="'EMPBE_CompanyInfoCenter_LeftFooterMenus_Tips'"
            :Title="$t('lbl_EMPBE_ProductInfo_Memu_Completion_Tips', { nums: 98 })">
            <template v-slot:Text>
                <b class="Title" > {{$t('lbl_EmpBE_ProInfo_Assistant')}}</b>
                <div class="" style="right: 32px;position: absolute;margin-top: -20px;"> 
                   <span>{{ $t('lbl_EMPBE_ProInfo_Left_Completion').replace('{percentage}',progress_Value) }}</span>
                </div>
            </template>
        </TipsAndPrivewDilog>
        <div class="row" style="" v-loading="Loading">
            <div style="    width: 100%;">
                <b-progress :value="progress_Value" class="CompanyCompletionProgress" variant="warning"></b-progress>

            </div>
             
        </div>
        <div class="needTodo" v-if="unFillFiledList&&unFillFiledList.length>0" >
            <div class="needTodo-header" @click="toggleNeedTodo">
              
              <div class="needTodo-title" >
                <span style="color: #E98024;font-weight: 600;">{{totalNotFilledCount}}</span> {{$t('lbl_EmpBE_ProInfo_pendingToOptimize')}}   
                <span style="" class="downIcon">
                <i :class="['fa', ItemListExpanded ? 'fa-chevron-up' : 'fa-chevron-down', 'needTodo-arrow']"></i>
                </span>   
               </div>
                
            </div>
            <div class="needTodo-content" v-show="ItemListExpanded">
                
                <!-- 这里可以添加助手内容 -->
                <div class="content-sub"  style="height:424px" v-if="!unFillFiledList" >
                  <el-table
                    v-loading="true" 
                    style="width: 100%"> </el-table> 
                </div>
                <div class="content-sub"  v-if="unFillFiledList" >
                 <div class="needTodo_sub" 
                 :class="temp_selectedTabName==item.name?'needTodo_sub_active':''" 
                 :tabName="item.name" v-for="(item, index) in unFillFiledList" 
                 :id="'needTodo_sub_'+index" name="needTodo_sub" :key="item.name" 
                 @click="toggleNeedTodo_sub(item.name)">
                    <!-- <div class="needTodo-header-sub" @click="toggleNeedTodo_sub(index+1)"> -->
                    <div class="needTodo-header-sub" > 
                    
                    <div class="needTodo-title-sub" > {{ item.lblName }}
                    <span style="position: absolute;right: 12px;">
                        <i :class="['fa', getExpandedStatusByIdx(index+1) ? 'fa-chevron-right' : 'fa-chevron-down', 'needTodo-arrow-sub']"></i>
                    </span>
                    <hr class="line" >
                    </div>

                    </div>
                    <!-- <div class="needTodo-content-sub"  v-show="getExpandedStatusByIdx(index+1)" > -->
                        <div class="needTodo-content-sub"  >
                        <!--list item -->
                         <ul class="listItem"   >
                          <li  v-for="(subitem, index) in item.todoList"  :key="index">
                          <span v-if="subitem.controlId=='Ability_Number'||subitem.controlId=='Ability_Unit'||subitem.controlId=='AbilityPeriod'" id="needToFill_ModelNum"  v-html="GetlblproductCapacityTitle"></span>
                          <span v-else v-html="resolveTodoLbl(subitem.lblName)"></span>
                         </li>
                          
                           
                        </ul>
                    </div>
                    </div>
                 
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
import { load } from '@progress/kendo-vue-intl';

export default {
    props: ["dataList","progressModel","selectedTabName"],
    data(){
        return{
            progress_Value:'-',
            temp_selectedTabName:'',
            totalNotFilledCount:0,
            Loading:false,
            ItemListExpanded: false,
            isHasScroll:false,//有滚动条的
            ItemListExpanded1: true,
            ItemListExpanded2: true,
            ItemListExpanded3: true,
            ItemListExpanded4: true,
            langId:936,
             unFillFiledList: [                
            { name: 'BasicInfo', lablName: this.$t('lbl_EMPBE_ProductInfo_Memu_BasicInfo'), todoList:[] },
            { name: 'PricingTradeInfo', lablName: this.$t('lbl_EMPBE_ProductInfo_Memu_PricingTradeInfo'), todoList:[] },
            { name: 'ProductDetail', lablName: this.$t('lbl_EMPBE_ProductInfo_Memu_ProductDetails'), todoList:[]}, 
            { name: 'ProductTags', lablName: this.$t('lbl_EMPBE_ProductInfo_Memu_ProductTags'), todoList:[] }
            ] 
        }
    },
    computed: {
        GetlblproductCapacityTitle(){
        console.log('lblproductCapacityTitle');
        var lblproductCapacityTitle= document.getElementById('lblproductCapacityTitle');
        if(lblproductCapacityTitle)
        return lblproductCapacityTitle.innerText;
        else{
            return this.$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductionCapacity',{ProductName:'your product'})
        } 
    }
    },
    mounted(){
        this.Loading=true;
        this.unFillFiledList=this.dataList;
        setTimeout(() => {
                this.Loading=false;
                this.progress_Value = this.progressModel&&this.progressModel.progress?this.progressModel.progress:'-';     

         }, 1500);
        this.langId = this.langid();
        this.temp_selectedTabName=this.selectedTabName; 
        // if(this.ItemListExpanded==true)
        // {
            
        //     var leftCardObj=document.getElementsByClassName('leftCard_proInfo')[0];     
        //     if (leftCardObj&&leftCardObj.scrollHeight>842) {
        //         this.isHasScroll=true;
        //         leftCardObj.style.width=leftCardObj.offsetWidth+15+'px';
        //     } 
        // }
                
    
    },
    methods: {
        resolveTodoLbl(lblName) {
            const key = String(lblName || '').trim();
            if (!key) return '';
            if (typeof this.$te === 'function' && this.$te(key)) {
                return this.$t(key);
            }
            // 驳回字段可能直接返回 FieldName 文案，非 i18n key
            const translated = this.$t(key);
            return translated === key ? key : translated;
        },
        toggleNeedTodo() {
            this.ItemListExpanded = !this.ItemListExpanded; 
             var leftCardObj=document.getElementsByClassName('leftCard_proInfo')[0]; 
             if(this.isHasScroll&&leftCardObj){
             if(this.ItemListExpanded==true) {  
                  leftCardObj.style.width=leftCardObj.offsetWidth+10+'px'; 
                }else{ 
                leftCardObj.style.width=(leftCardObj.offsetWidth-10)+'px';   
                } 
                }
             
        },
        //  toggleNeedTodo_sub(idx) {
        //     if(idx==1){
        //     this.ItemListExpanded1 = !this.ItemListExpanded1;
        //     }else if(idx==2){
        //          this.ItemListExpanded2 = !this.ItemListExpanded2;
        //     }else if(idx==3){
        //         this.ItemListExpanded3 = !this.ItemListExpanded3;
        //     }else if(idx==4){
        //         this.ItemListExpanded4 = !this.ItemListExpanded4;
        //     }
           
        // },  
         toggleNeedTodo_sub(tabName) {
            // var tabObj=document.getElementById("tab_"+tabName);   
            //   console.log("tabObj:"+tabName);  
            // if (tabObj) {
              //  console.log("tabObj:"+tabObj.id);
            //  tabObj.click();
            // }
            console.log('toggleNeedTodo_sub'+tabName);
            this.$emit("selected",tabName); 
            //this.temp_selectedTabName=tabName;
        },  
        getExpandedStatusByIdx(idx){
           if(idx==1){
            return this.ItemListExpanded1 ;
            }else if(idx==2){
                return this.ItemListExpanded2 ;
            }else if(idx==3){
                return this.ItemListExpanded3 ;
            }else if(idx==4){
                return this.ItemListExpanded4 ;
            }
        },
        langid() {
       return localStorage.getItem("currentLangId");
        },
       
    },
    watch:{
        dataList: {
            handler(newVal) { 
                if (newVal && newVal.length >= 0) {
                  this.unFillFiledList=newVal;
                   this.isHasScroll=newVal.length>=2;
                    this.totalNotFilledCount = newVal.reduce((sum, item) => {
                        return sum + item.todoList.length;
                    }, 0);
                }
            },
            deep: true,
            immediate: true
        },
        progressModel: {
            handler(newVal) {
              
                if (newVal && newVal.progress !== undefined) {
                    this.Loading = true;
                    setTimeout(() => {
                        this.Loading = false;
                        this.progress_Value = newVal.progress;
                    }, 1500);
                }
            },
            deep: true,
            immediate: true
        },
         selectedTabName: {
            handler(newVal, oldVal) {
                // 确保当父组件的 selectedTabName 变化时，子组件也跟着更新
                if (newVal) {
                   this.temp_selectedTabName = newVal; 
                }
            },
            immediate: true
        }
    }

}
</script>
<style lang="scss" scoped>
.CardFooter {
    // margin-top: 24px;
}
.CardFooter .Title {
  color: var(--On-Surface-80, rgba(0, 0, 0, 0.80));
// font-family: Inter;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 130%; /* 20.8px */
}
.progress {
    border-radius: 15px !important;
    margin: 8px 16px;
}

.CompanyCompletionProgress ::v-deep .progress-bar {
    background-color: #E98024 !important;
}

.needTodo { 
        margin: 8px 0;
}

.needTodo-header {
    
    align-items: center;
    cursor: pointer; 
    
    user-select: none;
}

.downIcon{
    position: absolute;
    right: 0;
    width: 32px;
    height: 32px;
    border-radius: 99px;
    
    align-items: center;
    justify-content: center;
    display: flex;
    top: 0;
    margin-top: -6px;
}
.needTodo-header:hover{

.downIcon{
    background:rgba(0, 0, 0, 0.03);
}
}

  .needTodo-header-sub {
    padding: 12px 12px;
    cursor: pointer;
    position: relative;
  }
.line {
    color:#F0E5E6;height: 1px;margin-bottom: 0px; 
    margin: 12px 0 -10px 0px;
}
 .content-sub{ 
    gap: 8px;
    display: grid; 
        overflow-y: auto;
    scrollbar-color: #8C8B99 #eee;
    scrollbar-width: thin;
    max-height: 424px;
    padding-right: 10px;
    width: 103%; 
 }
 .needTodo_sub{
    font-size: 14px;
    // font-family: Inter;
    font-weight: 600;
    line-height: 18.20px;
    background: #F9F9F9;
    border-radius: 12px;
    border: 1px solid #F0E5E6;
 }
 .needTodo_sub_active,
 .needTodo_sub:hover {
    background: #ffffff;
    border: 1px solid #00000040;

    .needTodo-arrow-sub {
      color: rgba(0, 0, 0, 0.80);
    }
  }

.needTodo-content-sub {
    padding: 0 12px 12px;
}

.listItem {
    margin: 8px 0 4px 20px;
    color: rgba(0, 0, 0, 0.80);
    font-size: 12px;
    line-height: 19.20px;
    cursor: pointer;
}
.listItem li {
   list-style: disc;  
   font-weight: 400;
}
.listItem li a{
   letter-spacing:unset
}
.needTodo-title {
    font-weight: 600;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.80);
        position: relative;
}

.needTodo-arrow {
    font-size: 14px;
    color: black;
    transition: transform 0.3s ease;
}

.needTodo-arrow-sub {
    font-size: 12px;
    color: #656061;
    // transition: transform 0.3s ease;
}


.needTodo-content {
    padding: 16px 0 0 0;
    animation: slideDown 0.3s ease;
} 
@keyframes slideDown {
    from {
        opacity: 0;
        max-height: 0;
    }
    to {
        opacity: 1;
        max-height: 500px;
    }
}
</style>